(function () {
  var root = document.querySelector('.cabn-global-cart');
  if (!root) return;

  var overlay = root.querySelector('.cart-ov');
  var drawer = root.querySelector('.cart');
  var itemsBox = root.querySelector('.cart-items');
  var subtotal = root.querySelector('[data-cabn-subtotal]');
  var saving = root.querySelector('.saverow');
  var wasTotal = root.querySelector('.wast');
  var warranty = root.querySelector('[data-cabn-warranty]');
  var currency = root.dataset.currencyCode || 'USD';
  var comparePrice = parseInt(root.dataset.cabnComparePrice || '0', 10);
  var cabnIds = (root.dataset.cabnVariantIds || '').split(',').map(Number).filter(Boolean);
  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var warrantyByQuantity = {
    1: { id: 45898130849871, label: 'Covered forever, just ' },
    2: { id: 45936601858127, label: 'Covers both Cabns forever, just ' },
    3: { id: 45936601890895, label: 'Covers all your Cabn devices forever, just ' }
  };
  var warrantyIds = Object.keys(warrantyByQuantity).map(function (key) { return warrantyByQuantity[key].id; });
  var warrantyPrices = {};
  var lastTrigger = null;

  function endpoint(path) { return routesRoot + path; }
  function money(cents) {
    var locale = document.documentElement.lang || navigator.language || 'en';
    var rounded = Math.round(cents);
    var digits = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).resolvedOptions().maximumFractionDigits;
    var minimum = digits && rounded % 100 !== 0 ? Math.min(2, digits) : 0;
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: minimum, maximumFractionDigits: digits }).format(cents / 100);
  }
  function cabnCount(cart) {
    return cart.items.reduce(function (total, item) { return total + (cabnIds.indexOf(item.variant_id) > -1 ? item.quantity : 0); }, 0);
  }
  function desiredWarranty(cart) {
    var count = cabnCount(cart);
    if (!count) return null;
    return warrantyByQuantity[Math.min(3, count)];
  }
  function request(path, options) {
    return fetch(endpoint(path), options).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }
  function changeLine(key, quantity) {
    return request('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }
  function addVariant(id) {
    return request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    });
  }
  function syncWarranty(cart) {
    var wanted = desiredWarranty(cart);
    var existing = cart.items.find(function (item) { return warrantyIds.indexOf(item.variant_id) > -1; });
    if (!wanted && existing) return changeLine(existing.key, 0).then(render);
    if (wanted && existing && existing.variant_id !== wanted.id) {
      return changeLine(existing.key, 0).then(function () { return addVariant(wanted.id); }).then(render);
    }
    return Promise.resolve({ cart: cart, wanted: wanted, existing: existing });
  }
  function loadWarrantyPrice(wanted) {
    if (!wanted) return;
    var copy = warranty.querySelector('.u2');
    if (warrantyPrices[wanted.id] !== undefined) {
      copy.textContent = wanted.label + money(warrantyPrices[wanted.id]);
      return;
    }
    request('variants/' + wanted.id + '.js').then(function (variant) {
      warrantyPrices[wanted.id] = variant.price;
      copy.textContent = wanted.label + money(variant.price);
    }).catch(function () { copy.textContent = 'Local price shown at checkout'; });
  }
  function itemMarkup(item) {
    var isCabn = cabnIds.indexOf(item.variant_id) > -1;
    var compare = isCabn && comparePrice ? '<s>' + money(item.quantity * comparePrice) + '</s>' : '';
    var meta = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="meta">' + item.variant_title + '</span>' : '';
    return '<div class="citem">' +
      '<span class="thumb" style="background-image:url(&quot;' + (item.image || '') + '&quot;)"></span>' +
      '<span style="flex:1;min-width:0"><span class="nm">' + item.product_title + '</span>' + meta +
      '<span class="qty"><button type="button" data-key="' + item.key + '" data-quantity="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
      '<span>' + item.quantity + '</span><button type="button" data-key="' + item.key + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
      '<button class="remove" type="button" data-key="' + item.key + '" data-quantity="0">Remove</button></span></span>' +
      '<span class="pr">' + compare + ' ' + money(item.final_line_price) + '</span></div>';
  }
  function paint(cart, wanted, existing) {
    itemsBox.innerHTML = cart.items.length ? cart.items.map(itemMarkup).join('') : '<div class="citem"><span class="meta">Your cart is empty.</span></div>';
    itemsBox.querySelectorAll('[data-key]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.disabled = true;
        changeLine(button.dataset.key, parseInt(button.dataset.quantity, 10)).then(render);
      });
    });

    var totalSaving = cart.original_total_price - cart.total_price;
    cart.items.forEach(function (item) {
      if (cabnIds.indexOf(item.variant_id) > -1 && comparePrice) totalSaving += Math.max(0, item.quantity * comparePrice - item.original_line_price);
    });
    subtotal.textContent = money(cart.total_price);
    saving.hidden = totalSaving <= 0;
    wasTotal.hidden = totalSaving <= 0;
    if (totalSaving > 0) {
      saving.textContent = 'You Save ' + money(totalSaving) + ' Today';
      wasTotal.textContent = money(cart.total_price + totalSaving);
    }

    warranty.hidden = !wanted;
    if (wanted) {
      loadWarrantyPrice(wanted);
      warranty.classList.toggle('added', Boolean(existing));
      warranty.querySelector('button').textContent = existing ? 'Added' : 'Add';
    }
  }
  function render() {
    return request('cart.js').then(syncWarranty).then(function (result) {
      if (result && result.cart) paint(result.cart, result.wanted, result.existing);
    });
  }
  function open(trigger) {
    lastTrigger = trigger || document.activeElement;
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cabn-cart-open');
    render();
    setTimeout(function () { root.querySelector('.x').focus(); }, 50);
  }
  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cabn-cart-open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  root.querySelectorAll('[data-cabn-cart-close]').forEach(function (button) { button.addEventListener('click', close); });
  warranty.querySelector('button').addEventListener('click', function () {
    request('cart.js').then(function (cart) {
      var wanted = desiredWarranty(cart);
      var existing = cart.items.find(function (item) { return wanted && item.variant_id === wanted.id; });
      if (!wanted) return null;
      return existing ? changeLine(existing.key, 0) : addVariant(wanted.id);
    }).then(render);
  });
  root.querySelectorAll('[data-cabn-quote]').forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(dot.dataset.cabnQuote, 10);
      root.querySelectorAll('.cq').forEach(function (quote, i) { quote.classList.toggle('active', i === index); });
      root.querySelectorAll('.dot').forEach(function (item, i) { item.classList.toggle('active', i === index); });
    });
  });
  window.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest || event.target.closest('.cabn-global-cart')) return;
    var trigger = event.target.closest('a[href$="/cart"],a[href*="/cart?"],[aria-label*="cart" i],[data-cart-icon]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(trigger);
  }, true);
  document.addEventListener('cart:update', function () { open(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && drawer.classList.contains('open')) close(); });
})();
